var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResponsive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 125,
    viewBox: "0 0 160 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_43)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.00195312 3C-0.00195312 1.34315 1.34119 0 2.99805 0H156.998C158.655 0 159.998 1.34315 159.998 3V23.163H-0.00195312V3ZM-0.00195312 24.163H159.998V121.082C159.998 122.738 158.655 124.082 156.998 124.082H2.99805C1.34119 124.082 -0.00195312 122.738 -0.00195312 121.082V24.163ZM27.0902 15.7258C29.2994 15.7258 31.0902 13.9228 31.0902 11.6986C31.0902 9.47444 29.2994 7.67139 27.0902 7.67139C24.8811 7.67139 23.0902 9.47444 23.0902 11.6986C23.0902 13.9228 24.8811 15.7258 27.0902 15.7258ZM11.095 15.7265C13.3042 15.7265 15.095 13.9235 15.095 11.6993C15.095 9.47517 13.3042 7.67212 11.095 7.67212C8.88589 7.67212 7.09502 9.47517 7.09502 11.6993C7.09502 13.9235 8.88589 15.7265 11.095 15.7265ZM47.0912 11.6986C47.0912 13.9228 45.3003 15.7258 43.0912 15.7258C40.882 15.7258 39.0912 13.9228 39.0912 11.6986C39.0912 9.47444 40.882 7.67139 43.0912 7.67139C45.3003 7.67139 47.0912 9.47444 47.0912 11.6986Z",
    fill: "url(#paint0_linear_347_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.63 42.449H81.3242C80.2196 42.449 79.3242 43.3444 79.3242 44.449V73.1021C79.3242 74.2066 80.2196 75.1021 81.3242 75.1021H142.63C143.735 75.1021 144.63 74.2066 144.63 73.1021V44.449C144.63 43.3444 143.735 42.449 142.63 42.449Z",
    fill: "url(#paint1_linear_347_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3242 85.7144H144.63",
    stroke: "#AFAFAF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3242 92.2449H144.63",
    stroke: "#AFAFAF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3242 98.7754H144.63",
    stroke: "#AFAFAF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 30C17.6863 30 15 32.6863 15 36V42.2012H60.6963V36C60.6963 32.6863 58.01 30 54.6963 30H21ZM60.6963 43.2012H15V113.362C15 116.675 17.6863 119.362 21 119.362H54.6963C58.01 119.362 60.6963 116.675 60.6963 113.362V43.2012ZM30.7476 37.1083C30.7476 36.8322 30.9715 36.6083 31.2476 36.6083H45.4643C45.7404 36.6083 45.9643 36.8322 45.9643 37.1083C45.9643 37.3845 45.7404 37.6083 45.4643 37.6083H31.2476C30.9715 37.6083 30.7476 37.3845 30.7476 37.1083ZM37.8481 114.284C39.2501 114.284 40.3867 113.148 40.3867 111.746C40.3867 110.344 39.2501 109.207 37.8481 109.207C36.446 109.207 35.3094 110.344 35.3094 111.746C35.3094 113.148 36.446 114.284 37.8481 114.284Z",
    fill: "url(#paint2_linear_347_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.085 50.7446H20.1914C19.0868 50.7446 18.1914 51.6401 18.1914 52.7446V61.5106C18.1914 62.6152 19.0868 63.5106 20.1914 63.5106H56.085C57.1896 63.5106 58.085 62.6152 58.085 61.5106V52.7446C58.085 51.6401 57.1896 50.7446 56.085 50.7446Z",
    fill: "url(#paint3_linear_347_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1914 69.0957L58.085 69.0958",
    stroke: "#AFAFAF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1914 75.4788H58.085",
    stroke: "#AFAFAF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1914 81.8618H58.085",
    stroke: "#AFAFAF",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_347_43",
    x1: -0.00514083,
    y1: 112,
    x2: 75.9972,
    y2: -9.72872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717186",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_347_43",
    x1: 111.977,
    y1: 42.449,
    x2: 111.977,
    y2: 75.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_347_43",
    x1: 15,
    y1: 110.426,
    x2: 70.9788,
    y2: 75.8058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717186",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_347_43",
    x1: 37.3403,
    y1: 50.7446,
    x2: 37.3403,
    y2: 63.5105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 125,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsive);
export default __webpack_public_path__ + "static/media/Responsive.4abb8d788ba439469db213d30e08ae8b.svg";
export { ForwardRef as ReactComponent };